<template>
  <div id="app">
    <!-- <div class="route-content"> -->
    <router-view />
    <!-- <router-view v-if="$route.meta.keepAlive"></router-view> -->
    <!-- </div> -->
  </div>
</template>
<!-- <script src="http://pv.sohu.com/cityjson?ie=utf-8"></script> -->

<script>
import $ from "jquery";
export default {
  name: "app",
  data () {
    return {};
  },
  computed: {},
  mounted () {
    //  this.getConfigJson();
  },
  methods: {}
};
</script>

<style>
* {
  margin: 0;
}
.el-table td.gutter,
.el-table th.gutter {
  display: none;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: none;
}
.el-table__fixed-right::before,
.el-table__fixed::before {
  display: none;
}

/* .el-table thead{
              color: white;
          } */
#app {
  width: 100vw;
  height: 100vh;
}
#app .route-content {
  width: 100%;
  height: 100%;
}

.navMonitor-popper {
  padding: 2px;
  min-width: 0;
}
.navMonitor-popper.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue